import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { Image } from '../../../../../common/image'
import IconSvg from '../../../corporatePerformanceScore/common/icon/predictiveModel.svg'
import classes from './index.module.scss'
import { Tivi } from './Tivi'

export const PredictiveModel = () => {
  return (
    <div className="dFlex" style={{ gap: 20 }}>
      <div className={[classes.predictiveModel, 'flexColumn'].join(' ')}>
        <div>
          <div className="flexColumn">
            <div className="flexColumn">
              <TextTitle val="score.standard.ABOUT_FIIN" />
              <Element
                elementName="p"
                style={{
                  fontSize: 14,
                  lineHeight: '24px',
                  color: '#3A414B',
                  paddingBottom: 12,
                }}
              >
                <Translate value="score.standard.ADVANTAGES_MODEL" />
              </Element>
            </div>
          </div>
          <ItemAdvantages val="score.standard.LIST_ADVANTAGES_MODEL.TEXT_1" />
          <ItemAdvantages val="score.standard.LIST_ADVANTAGES_MODEL.TEXT_2" />
          <ItemAdvantages val="score.standard.LIST_ADVANTAGES_MODEL.TEXT_3" />
          <div className="flexColumn" style={{ paddingTop: 8, gap: 20 }}>
            <TextBold val="score.standard.LIST_ADVANTAGES_MODEL.TEXT_4" />
            <TextBold val="score.standard.LIST_ADVANTAGES_MODEL.TEXT_5" />
            <TextBold val="score.standard.LIST_ADVANTAGES_MODEL.TEXT_6" />
          </div>
        </div>
        <div>
          <TextTitle val="score.standard.QUESTION" />
        </div>
      </div>
      <div>
        <Tivi />
      </div>
    </div>
  )
}

const ItemAdvantages = ({ val }) => {
  return (
    <Element
      className={classes.ItemAdvantages}
      style={{ boxShadow: '0px 10px 12px rgba(0, 0, 0, 0.2)' }}
    >
      <Image src={IconSvg} />
      <Element
        elementName="p"
        style={{ lineHeight: '16px', padding: '6px 10px' }}
      >
        <Translate value={val} />
      </Element>
    </Element>
  )
}

const TextBold = ({ val }) => {
  return (
    <Element
      elementName="p"
      style={{
        fontWeight: 600,
        lineHeight: '16px',
        color: '#3A414B',
      }}
    >
      <Translate value={val} />
    </Element>
  )
}

const TextTitle = ({ val }) => {
  return (
    <Element
      elementName="p"
      style={{
        fontWeight: 500,
        fontSize: 20,
        lineHeight: '24px',
        color: '#191D25',
      }}
    >
      <Translate value={val} />
    </Element>
  )
}
